import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import microRegionReadAction from './microRegionRead.action.json' assert { type: 'json' }

const microRegionReadDefinition = defineReadAutoAction(microRegionReadAction, 'microRegion')

export default microRegionReadDefinition
